import { AxiosPromise } from 'axios';
import { http } from 'services';

/** With a notebook id, only that notebook's sources; without one, the caller's whole list. */
export const GetAll = (notebookId?: string): AxiosPromise =>
  http.request.get('/api/documents', { params: notebookId ? { notebookId } : undefined });

export const GetById = (id: string): AxiosPromise =>
  http.request.get(`/api/documents/${id}`);

interface UploadOptions {
  description?: string;
  /** The notebook the source joins. A document belongs to exactly one. */
  notebookId?: string;
}

export const buildUploadFormData = (file: File, title: string, { description, notebookId }: UploadOptions = {}): FormData => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('title', title);
  if (description) {
    formData.append('description', description);
  }
  if (notebookId) {
    formData.append('notebookId', notebookId);
  }
  return formData;
};

export const Upload = (file: File, title: string, options?: UploadOptions): AxiosPromise =>
  // Do NOT set Content-Type manually — Axios must set it automatically so it includes
  // the multipart boundary (e.g. "multipart/form-data; boundary=----XYZ").
  // A manually set header strips the boundary and causes the server to fail parsing the file.
  http.request.post('/api/documents/upload', buildUploadFormData(file, title, options));

export const Update = (id: string, data: { title?: string; description?: string }): AxiosPromise =>
  http.request.put(`/api/documents/${id}`, data);

export const Delete = (id: string): AxiosPromise =>
  http.request.delete(`/api/documents/${id}`);

export const RetryProcessing = (id: string): AxiosPromise =>
  http.request.post(`/api/documents/${id}/retry-processing`);

export const GetFile = (id: string): AxiosPromise<Blob> =>
  http.request.get(`/api/documents/${id}/file`, { responseType: 'blob' });
